module.exports = __webpack_public_path__ + "img/project-structure.0bb81704.png";